import React, { memo, useContext, useState, useRef, useEffect } from 'react';
import { createUseStyles, useTheme, Icon, Text } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';
import CopilotSidebarChatTab from './CopilotSidebarChatTab';
import CopilotSidebarAgentsTab from './CopilotSidebarAgentsTab';
import CopilotSidebarHistoryTab from './CopilotSidebarHistoryTab';
import CopilotWidgetHeader from './CopilotWidgetHeader';
import AgentsIcon from './components/AgentsIcon/Agents';
import CopilotLightIcon from './components/CopilotLightIcon';
import { CopilotContext } from '../Context';

import styles from './styles';
const useStyles = createUseStyles(styles, 'CopilotSidebar');

const CopilotSidebar = ({ onClose, userData }) => {
    const { t } = useWeb5Context();
    const theme = useTheme();
    const classes = useStyles();
    const [activeTab, setActiveTab] = useState('chat');
    const { refreshAgents } = useContext(CopilotContext);
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            refreshAgents();
            isFirstRender.current = false;
        }
    }, [refreshAgents]);

    return (
        <div className={classes.root}>
            <div className={classes.mainContent}>
                <div className={classes.verticalTabs}>
                    <div className={classes.copilotIcon}>
                        <CopilotLightIcon />
                    </div>
                    <button
                        className={
                            activeTab === 'chat'
                                ? `${classes.tabButton} ${classes.tabButtonActive}`
                                : classes.tabButton
                        }
                        onClick={() => setActiveTab('chat')}
                    >
                        <Icon
                            className={classes.tabIcon}
                            name="chat"
                            color={theme.colors.primary.black}
                        />
                        <Text type="caption">{t('label_copilot_tab_chat')}</Text>
                    </button>
                    <button
                        className={
                            activeTab === 'history'
                                ? `${classes.tabButton} ${classes.tabButtonActive}`
                                : classes.tabButton
                        }
                        onClick={() => setActiveTab('history')}
                    >
                        <Icon
                            className={classes.tabIcon}
                            name="clock"
                            color={theme.colors.primary.black}
                        />
                        <Text type="caption">{t('label_copilot_tab_history')}</Text>
                    </button>
                    <button
                        className={
                            activeTab === 'agents'
                                ? `${classes.tabButton} ${classes.tabButtonActive}`
                                : classes.tabButton
                        }
                        onClick={() => setActiveTab('agents')}
                    >
                        <AgentsIcon className={classes.tabIcon} />
                        <Text type="caption">{t('label_copilot_tab_agents')}</Text>
                    </button>
                </div>
                <div className={classes.tabContent}>
                    <CopilotWidgetHeader onClose={onClose} />
                    <div className={classes.tabContentContainer}>
                        {activeTab === 'chat' && <CopilotSidebarChatTab />}
                        {activeTab === 'history' && <CopilotSidebarHistoryTab />}
                        {activeTab === 'agents' && <CopilotSidebarAgentsTab />}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(CopilotSidebar);
